export default __webpack_public_path__ + "assets/images/948bc1abbf294b4839b158cff48c7896.jpeg";